import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { requestPasswordReset } from "@Api/Auth";
import Button from "@Components/Button";
import Form, { InputType } from "@Components/Form";
import BackArrow from "@Components/Icons/BackArrow";
import PredictyIconEyesOpen from "@Components/Icons/ChatBot/Predicty/PredictyEyesOpen";
import buttons from "@Components/Sass/buttons.module.scss";
import GetPath from "@Helpers/GetPath";
import { LOGIN } from "@Shared/Paths/Auth";
import { addNotification } from "@Store/Actions/Notifications";
import styles from "./../Login/index.module.scss";
class Reset extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: { username: "" },
            requestSent: false,
            errors: {},
        };
    }
    inputChange = (data) => {
        this.setState({ data });
    };
    resetPassword = () => {
        return requestPasswordReset(this.state.data.username).then(() => {
            this.setState({
                requestSent: true,
            });
        });
    };
    goBack = () => {
        return this.props.goBack();
    };
    render() {
        if (this.state.requestSent) {
            return (React.createElement("div", { className: styles.mainContent },
                React.createElement("div", { className: styles.centered },
                    React.createElement(PredictyIconEyesOpen, { className: styles.logo })),
                React.createElement("div", { className: styles.heading },
                    React.createElement("h1", { className: styles.title }, "Check your email"),
                    React.createElement("p", { className: styles.subtitle },
                        "We sent a password reset link to",
                        " "),
                    React.createElement("p", { className: styles.subtitle },
                        React.createElement("strong", null, this.state.data.username))),
                React.createElement("div", { className: styles.backToLoginSection },
                    React.createElement(NavLink, { to: GetPath(LOGIN), className: styles.backToLogin },
                        React.createElement(BackArrow, null),
                        "Back to log in"))));
        }
        return (React.createElement("div", { className: styles.mainContent },
            React.createElement("div", { className: styles.centered },
                React.createElement(PredictyIconEyesOpen, { className: styles.logo })),
            React.createElement("div", { className: styles.heading },
                React.createElement("h1", { className: styles.title }, "Forgot Password?")),
            React.createElement(Form, { className: styles.form, submit: this.resetPassword, labelLeft: false, input: [
                    {
                        label: "Email",
                        name: "username",
                        className: styles.inputForm,
                        inputClassName: styles.inputInner,
                        type: InputType.TextNew,
                        placeholder: "Enter your email",
                    },
                ], buttons: false, change: this.inputChange, data: this.state.data, errors: this.state.errors },
                React.createElement("div", { className: styles.login },
                    React.createElement("div", { className: `${buttons.buttonGroupCenter} ${styles.noMargin}` },
                        React.createElement(Button, { cta: true, type: "submit" }, "RESET PASSWORD")))),
            React.createElement("div", { className: styles.backToLoginSection },
                React.createElement(NavLink, { to: GetPath(LOGIN), className: styles.backToLogin },
                    React.createElement(BackArrow, null),
                    "Back to log in"))));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        notify: (data) => addNotification(dispatch, data),
    };
};
export default connect(null, mapDispatchToProps)(Reset);
